import { Descriptions, Divider, Spin } from "antd";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { setActiveObj } from "../../../features/obj/objSlice";
import moment from "moment";

function FarmerDetails() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { activeObjFarmers } = useSelector((state) => ({
    activeObjFarmers: state.obj.activeObj["farmers"],
  })); 
  const personalItems = [
    {
      key: "1",
      label: "ID Number",
      children: activeObjFarmers?.usrNationalId ?? "N/A",
    },
    {
      key: "5",
      label: "County",
      children: activeObjFarmers?.usrCountyName ?? "N/A",
    },
    {
      key: "2",
      label: "Email",
      children: activeObjFarmers?.email ?? "N/A",
    },
    {
      key: "3",
      label: "Location",
      children: activeObjFarmers?.usrPhysicalLocation ?? "N/A",
    },
    {
      key: "4",
      label: "Phone",
      children: activeObjFarmers?.phoneNumber ?? "N/A",
    },
    {
      key: "6",
      label: "Registration Date",
      children: (
        <div>
          {activeObjFarmers?.usrCreatedDate
            ? moment(activeObjFarmers?.usrCreatedDate)?.format(
                "DD-MM-YYYY"
              )
            : "--"}
        </div>
      ),
    },
  ];
  const farmItems = [
    {
      key: "1",
      label: "Land Size",
      children: activeObjFarmers?.usrLandSize ?? "N/A",
    },
    {
      key: "5",
      label: "Water Source",
      children: activeObjFarmers?.usrWaterSource ?? "N/A",
    },
    {
      key: "2",
      label: "Major Crops",
      children: activeObjFarmers?.usrMajorCrop ?? "N/A",
    },
  ];
  const contactItems = [
    {
      key: "1",
      label: "Name",
      children: activeObjFarmers?.alternateContact ?? "N/A",
    },
    {
      key: "5",
      label: "Phone",
      children: activeObjFarmers?.alternatePhoneNumber ?? "N/A",
    },
  ];
  const handleEdit = async () => {
    await dispatch(setActiveObj({ key: "farmers", data: activeObjFarmers }));
    await navigate("/farmers-add");
  };
  return (
    <div className="mt-[3.63rem] white_card flex-1   flex flex-col">
      <div className="flex items-center justify-between">
        <div className="details_h">Information</div>
        <div className="w-[100px]">
          <button
            onClick={handleEdit}
            key="submit"
            type="submit"
            className="cstm-btn-2"
          >
            Edit
          </button>
        </div>
      </div>
      <div className="mt-[1rem]">
        <Divider />
      </div>

      <div className="flex lg:flex-row flex-col gap-y-10 mt-[2.5rem]">
        <Descriptions
          column={1}
          colon={false}
          title="Personal Details"
          items={personalItems}
        />

        <Descriptions
          column={1}
          colon={false}
          title="Farm Details"
          items={farmItems}
        />

        <Descriptions
          column={1}
          colon={false}
          title="Alternate Contact Persons"
          items={contactItems}
        />
      </div>
    </div>
  );
}

export default FarmerDetails;
